import React from 'react'

import { Alert, Box, HeaderBody, GameButton } from '@fedsim/components'
import { useBrands } from 'contexts/Brand'
import { routesList } from 'constants/routes'
import { useNavigate } from 'react-router-dom'

function Instructions() {
  const { imported: brands } = useBrands()
  const navigate = useNavigate()
  const onClick = () => navigate(routesList.OFFICE.path)
  const hasEnoughBrands = brands.length > 0
  const preText = [
    'To use pre-made brands, wrestlers, and championships, click "Import" on the brand of your choice.',
    'When you have a few brands set up, visit your office to begin planning live events, matches, and managing your federations.',
    'If you prefer to start from scratch, go to the CMS on the sidebar & get ready to create & assign everything yourself.'
  ]
  const postText = [
    `You've successfully imported ${brands.length} brands! Now, let's start planning your live shows, roster, leagues, and championships.`,
    "It's time to take center stage and transform your fantasy league into the ultimate main event!"
  ]
  const texts = hasEnoughBrands ? postText : preText
  const severity = hasEnoughBrands ? 'success' : 'info'
  return (
    <Alert severity={severity}>
      <HeaderBody>
        {texts.map((text, index) => (
          <Box key={index} tabIndex={0}>{text}</Box>
        ))}
      </HeaderBody>
      <br />
      {hasEnoughBrands &&
        <GameButton color="inherit" onClick={onClick}>
          Go to the Office
        </GameButton>}
    </Alert>
  )
}

export default Instructions
